import { LayoutHOC } from 'base/ui/layout/layout';
import React from 'react'
import { createQnP } from './QaP';


export const createQnPPage = (layoutHOC: LayoutHOC) => {
    return layoutHOC(createQnP());
};